import { PageHeader } from '@/components/common/PageHeader';
import { DirectorySection } from '@/features/trusted-partners/components/DirectorySection';
import { PerksSection } from '@/features/trusted-partners/components/PerksSection';
import { TrustedPartnersHero } from '@/features/trusted-partners/components/TrustedPartnersHero';
import { TRUSTED_PARTNERS_STRINGS as S } from '@/features/trusted-partners/trusted-partners.constants';

/**
 * Network > Trusted Partners (FR-111): the hero, the Partner Directory preview,
 * and the Startup Perks & Special Offers section. Open to every logged-in
 * persona (A-90). Thin by design (ADR FE-1): each section owns its own query.
 */
export function TrustedPartnersPage() {
  return (
    <div className="min-h-full bg-page-bg">
      <PageHeader title={S.PAGE_TITLE} />
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 py-8">
        <TrustedPartnersHero />
        <DirectorySection />
        <PerksSection preview />
      </div>
    </div>
  );
}
